import React, {useState, useEffect, useReducer, useRef} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Modal from '../../../Common/Modal/Modal';
import MotifModalBody from '@ey/motif-react-wrapper/ModalBody';
import styled from 'styled-components';
import {SVGICONS} from '@ey/icons';
import {labels} from '../../../../util/utils';
import Input from '../../../CoreWrappers/Input';
import AddUser from './AddUser';
import DashboardViews from './DashboardViews';
import AddNewDomain from './AddNewDomain';
import AddExistingDomain from './AddExisitingDomain';
import AddElementButton from './AddElementButton';
import {GroupContext} from './Helper/GroupContext';
import {initialstate} from './Helper/initialstate';
import * as groupActiontypes from './Helper/GroupActionTypes';
import reducer from './Helper/GroupReducer';
import env from '../../../../util/env';
import {serviceURL, promiseAreas, UserType} from '../../../../util/uiconstants';
import TrackerLoader from '../../../Common/LoadingIndicator/TrackerLoader';
import ErrorSummary from '../../../Common/ErrorSummary/ErrorSummary';
import utility from '../../../../util/utilityfunctions';
import {setIsModalOpen} from '../../../../actions/AccessGroups/SetIsModalOpen';
import {
	setEditAccessGroupMode,
	setMultiSelectMode,
	editAccessGroupLocal,
	getProjectAccessGroups,
	createAccessGroup,
	updateAccessGroup
} from '../../../../actions/AccessGroups/Accessgroupactions';
import {getProjectEntities} from '../../../../actions/Project/projectAction';
import {raiseJSValidationError} from '../../../../actions/erroractions';

const AddNewGroupModal = (props) => {
	const [groupName, setGroupName] = useState('');
	const [showNameValidation, setShowNameValidation] = useState(false);
	const [isSaving, setisSaving] = useState(false);
	const [noViewSelected, setNoViewSelected] = useState(false);
	const [domainError, setDomainError] = useState(false);
	const [userError, setUserError] = useState(false);
	const [domainEmpty, setDomainEmpty] = useState(false);
	const [Usercounter, setUserCounter] = useState(0);
	const [DomainCounter, setDomainCounter] = useState(0);

	const [userList, setUserList] = useState([]);
	const [domainList, setDomainList] = useState([]);
	const [exdomains, setExdomains] = useState([]);

	const [state, localdispatch] = useReducer(reducer, initialstate);
	const isEditMode = useSelector((store) => store.isEditMode.activated);
	const isGroupEditMode = useSelector((store) => store.isGroupEditMode);
	const ErrorRef = useRef(null);
	const globalDispatch = useDispatch();
	const project = useSelector((store) => store.newProject);

	useEffect(() => {
		if (_.some(state.users) || _.some(state.domains) || _.some(state.views)) {
			localdispatch({type: groupActiontypes.CLEAR_STATE});
		}
	}, []);

	//Used for edit group - initialising the modal with previous data
	useEffect(() => {
		if (props.selectedGroup && props.showModal && isGroupEditMode) {
			const domainArray = [];
			const userArray = [];
			const domainsContextArray = [];
			const usersContextArray = [];
			const groupContextState = {};
			let localDomainCounter = 0;
			let localUserCounter = 0;
			props.selectedGroup.domains.forEach((domain) => {
				domainArray.push({
					id: `domain_${localDomainCounter}`,
					isEmpty: false,
					isDuplicate: false,
					button: `${1}`,
					isOld: true
				});
				domainsContextArray.push({id: `domain_${localDomainCounter}`, domainName: domain, isEmpty: false, isOld: true});
				localDomainCounter = ++localDomainCounter;
			});
			setDomainCounter(localDomainCounter);
			setDomainList(domainArray);
			setDomainError(false);

			props.selectedGroup.users.forEach((user) => {
				if (user.roles && user.roles.indexOf('admin') > -1) {
					userArray.push({id: `user_${localUserCounter}`, isEmpty: false});
					usersContextArray.push({
						id: `user_${localUserCounter}`,
						emailAddress: user.emailAddress,
						userId: user.userId,
						firstName: user.firstName,
						lastName: user.lastName,
						isInternal: user.isInternal || (user.userType !== UserType.Member ? false : true),
						isEmpty: false,
						roles: user.roles
					});
					localUserCounter = ++localUserCounter;
				}
			});
			setUserCounter(localUserCounter);
			setUserList(userArray);

			groupContextState.domains = domainsContextArray;
			groupContextState.users = usersContextArray;

			localdispatch({
				type: groupActiontypes.SET_GROUP_STATE,
				payload: {
					projectId: props.selectedGroup.projectId,
					groupId: props.selectedGroup.accessGroupId,
					groupName: props.selectedGroup.groupName,
					views: props.selectedGroup.views,
					users: usersContextArray,
					domains: domainsContextArray,
					isBuiltin: false,
					type: 'accessGroup',
					isDuplicate: false
				}
			});
			setGroupName(props.selectedGroup.groupName);
		}
	}, [props.showModal]);

	useEffect(() => {
		if (state.views.length > 0 && noViewSelected == true) {
			setNoViewSelected(false);
		}

		if (userList.length == 0) {
			setUserError(false);
		}
	}, [state.views, state.users]);

	useEffect(() => {
		if (state.domains.length > 0 || domainList.length > 0) {
			setDomainEmpty(false);
		}

		if (domainList.length == 0) {
			setDomainError(false);
		}

		if (domainList.length > state.domains.length) {
			setDomainEmpty(false);
		}
	}, [state.domains, domainList]);

	const loadGroups = (projectId) => {
		let url = `${env.getBaseURL(serviceURL)}Projects/${projectId}/Groups`;
		globalDispatch(getProjectAccessGroups(url));
	};

	const loadProjectEntities = (projectId) => {
		let url = `${env.getBaseURL(serviceURL)}Projects/${projectId}/Entities`;
		globalDispatch(getProjectEntities(url));
	};

	const onInputChange = (e) => {
		if (!e.target.value || e.target.value.length > 100 || _.trim(e.target.value).length <= 0) {
			setShowNameValidation(true);
		} else {
			setShowNameValidation(false);
		}
		setGroupName(e.target.value);
	};

	const setEmptyDomain = (id, value) => {
		let newDomainList = [...domainList];
		let domainToEmpty = domainList.findIndex((el) => el.id === id);
		if (domainToEmpty >= 0) {
			newDomainList[domainToEmpty].isEmpty = value;
		}

		if (domainError && !value) {
			setDomainError(false);
		}
		setDomainList([...newDomainList]);
	};

	const setDomainDuplicate = (id, value) => {
		let newDomainList = [...domainList];
		let domainToDuplicate = domainList.findIndex((el) => el.id === id);
		if (domainToDuplicate > 0) {
			newDomainList[domainToDuplicate].isDuplicate = value;
		}
		setDomainList([...newDomainList]);
	};

	const adminValidator = () => {
		let isValidData = true;
		if (state.users.some((el) => el.isEmpty == true) || userList.some((el) => el.isEmpty == true)) {
			isValidData = false;
		}
		return isValidData;
	};

	const domainValidator = () => {
		let isValidData = true;
		if (DomainCounter > 0) {
			if (state.domains.length < domainList.length) {
				// To check if the user has entered any domain or not
				setDomainError(true);
				isValidData = false;
			} else setDomainError(false);

			if (state.isDuplicate) {
				// Checks if duplication in domains is present - set by individual components
				setDomainError(true);
				isValidData = false;
			} else setDomainError(false);

			const inValidDomains = state.domains.some((el) => el.isEmpty === true || !el.isValidDomain);
			const emptyRow = domainList.some((el) => el.isEmpty == true);
			if (inValidDomains || emptyRow) {
				setDomainError(true);
				isValidData = false;
			} else setDomainError(false);
		}

		return isValidData;
	};

	const isDataValid = () => {
		let isValidData = true;

		if (!domainValidator()) {
			isValidData = false;
			setDomainError(true);
		}

		if (state.views.length == 0) {
			setNoViewSelected(true); // No view selected
			isValidData = false;
		}

		if (groupName == '') {
			setShowNameValidation(true); // No group name entered
			isValidData = false;
		}

		if (state.users.length < userList.length) {
			// To check if the user has selected any member/quest or not
			setUserError(true);
			isValidData = false;
		} else if (userList.length == 0) {
			// Unset required error if user has removed the last row/only row
			setUserError(false);
		}

		const emptyDomain = state.domains.some((el) => el.isEmpty == true);
		const emptyUser = state.users.some((el) => el.isEmpty == true);

		if (emptyDomain || emptyUser) {
			isValidData = false;
		}

		return isValidData;
	};

	// Add user row
	const addAdminbuttonClick = () => {
		setUserList([...userList, {id: `user_${Usercounter}`, isEmpty: false}]);
		setUserCounter(Usercounter + 1);
		setUserError(false);
	};

	// Remove user row
	const removeInputRowUser = (key) => {
		const newUserList = [...userList];
		const users = newUserList.filter((el) => el.id !== key);
		setUserList([...users]);
	};

	// Add domain row
	const addDomainbuttonClick = (val) => {
		setDomainList([
			...domainList,
			{id: `domain_${DomainCounter}`, isEmpty: true, isValidDomain: true, isDuplicate: false, button: `${val}`}
		]);
		setDomainCounter(DomainCounter + 1);
		setDomainError(false);
	};

	// Remove domain row
	const removeDomainRow = (key) => {
		const newdomains = [...domainList];
		const domains = newdomains.filter((el) => el.id !== key);
		setDomainList([...domains]);
	};

	useEffect(() => {
		const found = state.domains.some((el) => el.isDuplicate === true);
		if (!found) {
			localdispatch({type: groupActiontypes.SET_DUPLICATE_VALIDATION, payload: {isDuplicate: false}});
		}
	}, [state.domains]);

	useEffect(() => {
		if (!props.showModal) {
			globalDispatch(setMultiSelectMode(false));
		}

		if (props.showModal) {
			globalDispatch(setMultiSelectMode(true));
		}
		globalDispatch(setIsModalOpen(!!props.showModal));
	}, [props.showModal]);

	useEffect(() => {
		if (props.showModal == true && props.accessgroups.length > 0) {
			let combinedArray = [];
			const arrayGroup = [...props.accessgroups];
			arrayGroup.map((g) => {
				g.domains.map((d) => {
					combinedArray.push(d);
				});
			});
			let newArray = [...new Set(combinedArray)];
			setExdomains(newArray);
		}
	}, [props.showModal]);

	const saveGroup = () => {
		if (isDataValid()) {
			setisSaving(true);
			//setSaveFailed(false);
			const newGroup = {};

			newGroup.groupName = groupName;
			newGroup.projectId = isGroupEditMode ? props.selectedGroup.projectId : project.Id;
			newGroup.views = _.map(state.views, ({value}) => {
				return value;
			});
			newGroup.users = _.map(state.users, ({emailAddress, firstName, lastName, roles, userId, isInternal,userType}) => {
				return {emailAddress, firstName, lastName, roles, userId, isInternal, userType};
			});

			if (props.selectedGroup) {
				let groupUsers = _.cloneDeep(props.selectedGroup.users);
				const nonAdminUsers = groupUsers.filter((user) => {
					return !user.roles.includes('admin');
				});

				newGroup.users = [...newGroup.users, ...nonAdminUsers];
			}

			_.forEach(newGroup.users,(user)=>{
				user.isInternal = user.isInternal || (user.userType !== UserType.Member ? false : true)
			})

			newGroup.domains = state.domains.map((d) => {
				return d.domainName;
			});

			let payloadData = {};

			let projectId = '';
			if (isEditMode && !isGroupEditMode) {
				projectId = project.id;
				newGroup.isRemoved = false;
				payloadData = newGroup;
			} else if (isGroupEditMode) {
				projectId = props.selectedGroup.projectId;
				newGroup.isRemoved = false;
				payloadData = newGroup;
			} else {
				projectId = project.Id;
				newGroup.isRemoved = false;
				payloadData = newGroup;
			}

			if (isGroupEditMode) {
				if (props.isProjectEditMode) {
					globalDispatch(editAccessGroupLocal(payloadData, props.selectedGroup.accessGroupId));
					clearState();
					localdispatch({type: groupActiontypes.CLEAR_STATE});
					if (props.onEditSuccess) {
						props.onEditSuccess();
					}

					props.toggleModalVisibility(false);
					globalDispatch(setIsModalOpen(false));
				} else {
					globalDispatch(
						updateAccessGroup(
							env.getBaseURL(serviceURL) + `Projects/${projectId}/Groups/${props.selectedGroup.accessGroupId}`,
							payloadData
						)
					)
						.then(() => {
							clearState();
							localdispatch({type: groupActiontypes.CLEAR_STATE});
							let promises = [];
							let promiseGroups = loadGroups(props.selectedGroup.projectId);
							promises.push(promiseGroups);
							let promiseEntities = loadProjectEntities(props.selectedGroup.projectId);
							promises.push(promiseEntities);
							Promise.all(promises);
							props.toggleModalVisibility(false);
							globalDispatch(setIsModalOpen(false));
						})
						.catch((error) => {
							let displayError = utility.getErrorMessage(error);
							let errorCodeFromApi2 = utility.getErrorCodeFromResponse(displayError);

							var errorMessageToDisplay =
								errorCodeFromApi2 === 314
									? utility.getErrorMessageFromResponse(displayError)
									: utility.getErrorFromResponse(error);
							if (errorMessageToDisplay) {
								globalDispatch(raiseJSValidationError(errorMessageToDisplay || ''));
							}
							if (ErrorRef.current) {
								// scroll to top. Error ref refers to section with tabIndex -1. tabIndex is needed to set focus.
								ErrorRef.current.focus();
							}
							setisSaving(false);
						});
				}
			} else {
				globalDispatch(createAccessGroup(env.getBaseURL(serviceURL) + `Projects/${projectId}/Group`, payloadData))
					.then(() => {
						clearState();
						localdispatch({type: groupActiontypes.CLEAR_STATE});
						props.toggleModalVisibility(false);
						globalDispatch(setIsModalOpen(false));
					})
					.catch((error) => {
						let displayError = utility.getErrorMessage(error);
						let errorMessage = utility.getErrorMessageFromResponse(displayError);
						globalDispatch(raiseJSValidationError(errorMessage));
						if (ErrorRef.current) {
							// scroll to top. Error ref refers to section with tabIndex -1. tabIndex is needed to set focus.
							ErrorRef.current.focus();
						}
						setisSaving(false);
					});
			}
		}
	};

	const clearState = () => {
		setisSaving(false);
		setUserCounter(0);
		setDomainCounter(0);
		setUserList([]);
		setDomainList([]);
		setDomainError(false);
		setDomainEmpty(false);
		setUserError(false);
		setGroupName('');
		setShowNameValidation(false);
		setNoViewSelected(false);
		globalDispatch(setEditAccessGroupMode(false));
		globalDispatch(setMultiSelectMode(false));
		localdispatch({type: groupActiontypes.CLEAR_STATE});
	};
	const modalProps = {
		modalbodystyle: 'no-padding'
	};
	return (
		<GroupContext.Provider value={{state: state, dispatch: localdispatch}}>
			<Modal 
			{...modalProps}
				show={props.showModal}
				onHide={() => {
					clearState();
					localdispatch({type: groupActiontypes.CLEAR_STATE});
					props.toggleModalVisibility(false);
					globalDispatch(setIsModalOpen(false));
				}}
				modalsize="small"
				showButtons
				confirmBtnTitle={isGroupEditMode ? labels.saveChanges : labels.addGroup}
				closeBtnTitle={labels.cancelLabel}
				title={isGroupEditMode ? labels.editaGroup : labels.addAGroup}
				modalContainerClass={isGroupEditMode ? 'edit-modal' : 'add-modal'}
				isOkButtonDisabled={isSaving}
				onOkClick={() => {
					saveGroup();
				}}
				closeTitle={labels.closeLabel}
			>
				<>
					<TrackerLoader
						areas={[promiseAreas.ACCESS_GROUP_AREA]}
						view="__"
						styleName="SaveGroupLoader"
						fullscreen={false}
					/>
					<ErrorSummary />
					<StyledMotifModalBody className="no-padding customScrollbar">
						<section className="modal-header modal-section">
							<>
								<h4>{isGroupEditMode ? labels.editNewGroupHeader : labels.addNewGroupHeader}</h4>
								<p>{labels.addNewGroupInstruction}</p>
							</>
							<section
								ref={ErrorRef}
								tabIndex={-1}
								className={`group-name-input-wrapper ${isGroupEditMode && 'padded-top'}`}
							>
								<div className="group-input-textbox">
									<Input
										label={labels.groupName}
										id={'groupName'}
										maxLength="100"
										value={groupName}
										errorMessage={showNameValidation ? labels.required : null}
										onChange={(e) => {
											onInputChange(e);
										}}
										clearButtonTitle={labels.clearAllValues}
									/>
								</div>
							</section>
						</section>
						<section className="group-administrators modal-section">
							<h4>{labels.groupAdministrators}</h4>
							<p>{labels.groupAdministratorsSubHeading}</p>
							<AddElementButton
								onClick={() => {
									adminValidator() && addAdminbuttonClick();
								}}
								label={labels.addAdministrator}
							/>
							<ul className="add-group-name">
								{userList.map((el) => {
									return (
										<li>
											<AddUser
												key={el.id}
												className="add-group-wrap"
												id={el.id}
												isNewAdd={el.isNewAdd}
												remove={removeInputRowUser}
												userError={userError}
												hideClearIcon={false}
											/>
										</li>
									);
								})}
							</ul>
						</section>
						<section className="dashboard-views modal-section">
							<DashboardViews isSaving={isSaving} views={isGroupEditMode ? props.selectedGroup.views : []} />
							{noViewSelected && (
								<span className="required-error">
									<SVGICONS styleName="medium" name={'error'} hoverText={labels.required} alt="req" />
									{labels.required}
								</span>
							)}
						</section>
						<section className="domains modal-section">
							<h4>{labels.domains}</h4>
							<p>{labels.domainSubHeading}</p>
							<section className="add-domain-buttons-container">
								<AddElementButton
									onClick={() => {
										domainValidator() && addDomainbuttonClick(1);
									}}
									label={labels.addNewDomain}
								/>
								<AddElementButton
									onClick={() => {
										domainValidator() && props.accessgroups.length > 0 && props.accessgroups.some(ac => ac.domains.length > 0) && addDomainbuttonClick(2);
									}}
									className={(props.accessgroups.length === 0 || !props.accessgroups.some(ac => ac.domains.length > 0)) && 'disabled'}
									label={labels.addExistingDomain}
								/>
							</section>
							<section className="domain-input-wrapper">
								{domainList.map((el) =>
									el.button == 1 ? (
										<AddNewDomain
											domainList={domainList}
											setEmptyDomain={setEmptyDomain}
											setDomainDuplicate={setDomainDuplicate}
											key={el.id}
											id={el.id}
											remove={removeDomainRow}
											domainError={domainError}
											isOld={el.isOld}
										/>
									) : (
										<AddExistingDomain
											domainList={domainList}
											setEmptyDomain={setEmptyDomain}
											setDomainDuplicate={setDomainDuplicate}
											key={el.id}
											id={el.id}
											remove={removeDomainRow}
											domainError={domainError}
											exDomains={exdomains}
										/>
									)
								)}
								{domainEmpty && !domainError && (
									<span className="required-error">
										<SVGICONS styleName="medium" name={'error'} hoverText={labels.required} alt="req" />
										{labels.required}
									</span>
								)}
							</section>
						</section>
					</StyledMotifModalBody>
				</>
			</Modal>
		</GroupContext.Provider>
	);
};

export default AddNewGroupModal;
const StyledMotifModalBody = styled(MotifModalBody)`
	.motif-loader.motif-progress-loader-container.SaveGroupLoader {
		z-index: 999;
		top: 6.4rem;
		height: 100%;
		left: 0;
		position: absolute;
	}
	padding: 1.5rem 2rem !important;
	max-height: 50rem;

	h4 {
		font-size: 1.6rem;
		font-weight: normal;
		margin: 0 0 1rem;
	}
	p {
		font-size: 1.2rem;
		font-weight: 300;
		margin-bottom: 0;
	}
	.required-error {
		font-size: 1.3rem;
		display: flex;
		align-items: center;
		color: ${(props) => props.theme.color[`red600`]};

		svg {
			fill: ${(props) => props.theme.color[`red600`]};
			margin-right: 0.5rem;
		}
	}

	.modal-section {
		margin-bottom: 3rem;
	}
	.modal-header {
		padding: 0;
		border-bottom: none;
		.group-name-input-wrapper {
			max-width: 45rem;
			.group-input-textbox {
				.motif-input{
					padding-right: 3rem !important;
				}
				svg {
					&.small {
						width: 2rem;
						height: 2rem;
						max-width: 2rem;
						max-height: 2rem;
					}
				}
			}
		}

		.padded-top {
			padding-top: 1.5rem;
		}
	}
	.group-administrators {
		ul {
			li {
				.react-select__input {
					input {
						width: 92% !important;
					}
				}
			}
		}

		.add-group-wrap {
			margin: 0;
			.search-box-wrapper {
				margin-left: 0;
				padding-bottom: 0;
				max-height: none;
				width: 40%;
				.userfield-row {
					display: flex;
					flex-direction: column;
				}

				.enterdetail-description {
					bottom: 0;
					margin-top: 0.5rem;
					margin-left: 0;
				}
			}

			.group-input-textbox {
				width: 25%;
			}

			.user-selectbox{				
				.clearall{
					margin-top: 0;
				}
			}

		}
	}
	.domains {
		.add-domains-button-container {
			display: flex;
		}
		.domain-input-wrapper {
			margin-top: 2rem;

			.motif-select-input {
				height: 4.4rem;
					padding: 2rem 0.5rem 0.8rem 1rem;
					svg {
						top: 1.3rem;
						fill: ${(props) => props.theme.color[`grey500`]};
					}
			}
			.motif-form-field-select-input {
				label {
					font-size: 1.3rem;
					font-weight: normal;
					padding-left: 1rem;
					top: 1.5rem;
				}
				&.motif-form-field-focused,
				&.motif-form-field-has-value {
					.motif-label {
						font-size: 1.1rem;
						top: 0.7rem;
					}
				}
			}
		}
	}
`;
